import { AxiosHttpClient } from 'api/axios';
import { useRepruaDeleteApi, useRepruaPatchApi } from 'api/shared_api_hooks';
import { ID } from 'entities';
import { Reservation, ReservationForm, ReservationFormKeys } from 'entities/reservation';
import { pick } from 'lodash';
import { ApiSet, BaseResponse } from 'rac';

type ReservationResponse = BaseResponse & {
  reservation: Reservation;
};

/**
 * 更新
 */
export function usePatchReservationApi(): ApiSet<ReservationResponse> & {
  execute: (reservationForm: ReservationForm) => void;
} {
  const api = useRepruaPatchApi<ReservationResponse, ReservationForm>(new AxiosHttpClient('user'), {
    initialResponse: { reservation: {} },
  });

  const execute = (reservationForm: ReservationForm) => {
    const path = `reservations/${reservationForm.id}`;
    api.execute(path, pick(reservationForm, ReservationFormKeys));
  };

  return { ...api, execute };
}

/**
 * 削除
 */
export function useDeleteReservationApi(): ApiSet<ReservationResponse> & { execute: (id: ID) => void } {
  const api = useRepruaDeleteApi<ReservationResponse>(new AxiosHttpClient('user'), {
    initialResponse: { reservation: {} },
  });

  const execute = (id: ID) => {
    const path = `reservations/${id}`;
    api.execute(path);
  };

  return { ...api, execute };
}
